/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { BooleanBaseResponse } from '../models/boolean-base-response';
import { BooleanDlmBaseResponse } from '../models/boolean-dlm-base-response';
import { PressureMachineCalibrationAttachmentDto } from '../models/pressure-machine-calibration-attachment-dto';
import { PressureMachineCalibrationAttachmentDtoBaseResponse } from '../models/pressure-machine-calibration-attachment-dto-base-response';
import { PressureMachineResponse } from '../models/pressure-machine-response';
import { PressureMachineResponseDlmBaseResponse } from '../models/pressure-machine-response-dlm-base-response';
import { PressureMachineResponseListDlmBaseResponse } from '../models/pressure-machine-response-list-dlm-base-response';

@Injectable({
  providedIn: 'root',
})
export class PressureMachineService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiPressureMachinePressureMachinesGet
   */
  static readonly ApiPressureMachinePressureMachinesGetPath = '/api/PressureMachine/pressure-machines';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPressureMachinePressureMachinesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPressureMachinePressureMachinesGet$Plain$Response(params?: {
    archived?: boolean;
  }): Observable<StrictHttpResponse<PressureMachineResponseListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PressureMachineService.ApiPressureMachinePressureMachinesGetPath, 'get');
    if (params) {
      rb.query('archived', params.archived, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PressureMachineResponseListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPressureMachinePressureMachinesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPressureMachinePressureMachinesGet$Plain(params?: {
    archived?: boolean;
  }): Observable<PressureMachineResponseListDlmBaseResponse> {

    return this.apiPressureMachinePressureMachinesGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<PressureMachineResponseListDlmBaseResponse>) => r.body as PressureMachineResponseListDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPressureMachinePressureMachinesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPressureMachinePressureMachinesGet$Json$Response(params?: {
    archived?: boolean;
  }): Observable<StrictHttpResponse<PressureMachineResponseListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PressureMachineService.ApiPressureMachinePressureMachinesGetPath, 'get');
    if (params) {
      rb.query('archived', params.archived, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PressureMachineResponseListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPressureMachinePressureMachinesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPressureMachinePressureMachinesGet$Json(params?: {
    archived?: boolean;
  }): Observable<PressureMachineResponseListDlmBaseResponse> {

    return this.apiPressureMachinePressureMachinesGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<PressureMachineResponseListDlmBaseResponse>) => r.body as PressureMachineResponseListDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiPressureMachineNewPressureMachinePost
   */
  static readonly ApiPressureMachineNewPressureMachinePostPath = '/api/PressureMachine/new-pressure-machine';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPressureMachineNewPressureMachinePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPressureMachineNewPressureMachinePost$Plain$Response(params?: {
    body?: PressureMachineResponse
  }): Observable<StrictHttpResponse<PressureMachineResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PressureMachineService.ApiPressureMachineNewPressureMachinePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PressureMachineResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPressureMachineNewPressureMachinePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPressureMachineNewPressureMachinePost$Plain(params?: {
    body?: PressureMachineResponse
  }): Observable<PressureMachineResponseDlmBaseResponse> {

    return this.apiPressureMachineNewPressureMachinePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<PressureMachineResponseDlmBaseResponse>) => r.body as PressureMachineResponseDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPressureMachineNewPressureMachinePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPressureMachineNewPressureMachinePost$Json$Response(params?: {
    body?: PressureMachineResponse
  }): Observable<StrictHttpResponse<PressureMachineResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PressureMachineService.ApiPressureMachineNewPressureMachinePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PressureMachineResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPressureMachineNewPressureMachinePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPressureMachineNewPressureMachinePost$Json(params?: {
    body?: PressureMachineResponse
  }): Observable<PressureMachineResponseDlmBaseResponse> {

    return this.apiPressureMachineNewPressureMachinePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<PressureMachineResponseDlmBaseResponse>) => r.body as PressureMachineResponseDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiPressureMachineEditPressureMachinePost
   */
  static readonly ApiPressureMachineEditPressureMachinePostPath = '/api/PressureMachine/edit-pressure-machine';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPressureMachineEditPressureMachinePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPressureMachineEditPressureMachinePost$Plain$Response(params?: {
    body?: PressureMachineResponse
  }): Observable<StrictHttpResponse<PressureMachineResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PressureMachineService.ApiPressureMachineEditPressureMachinePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PressureMachineResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPressureMachineEditPressureMachinePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPressureMachineEditPressureMachinePost$Plain(params?: {
    body?: PressureMachineResponse
  }): Observable<PressureMachineResponseDlmBaseResponse> {

    return this.apiPressureMachineEditPressureMachinePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<PressureMachineResponseDlmBaseResponse>) => r.body as PressureMachineResponseDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPressureMachineEditPressureMachinePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPressureMachineEditPressureMachinePost$Json$Response(params?: {
    body?: PressureMachineResponse
  }): Observable<StrictHttpResponse<PressureMachineResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PressureMachineService.ApiPressureMachineEditPressureMachinePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PressureMachineResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPressureMachineEditPressureMachinePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPressureMachineEditPressureMachinePost$Json(params?: {
    body?: PressureMachineResponse
  }): Observable<PressureMachineResponseDlmBaseResponse> {

    return this.apiPressureMachineEditPressureMachinePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<PressureMachineResponseDlmBaseResponse>) => r.body as PressureMachineResponseDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiPressureMachineDeletePressureMachinePost
   */
  static readonly ApiPressureMachineDeletePressureMachinePostPath = '/api/PressureMachine/delete-pressure-machine';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPressureMachineDeletePressureMachinePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPressureMachineDeletePressureMachinePost$Plain$Response(params?: {
    body?: PressureMachineResponse
  }): Observable<StrictHttpResponse<PressureMachineResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PressureMachineService.ApiPressureMachineDeletePressureMachinePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PressureMachineResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPressureMachineDeletePressureMachinePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPressureMachineDeletePressureMachinePost$Plain(params?: {
    body?: PressureMachineResponse
  }): Observable<PressureMachineResponseDlmBaseResponse> {

    return this.apiPressureMachineDeletePressureMachinePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<PressureMachineResponseDlmBaseResponse>) => r.body as PressureMachineResponseDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPressureMachineDeletePressureMachinePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPressureMachineDeletePressureMachinePost$Json$Response(params?: {
    body?: PressureMachineResponse
  }): Observable<StrictHttpResponse<PressureMachineResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PressureMachineService.ApiPressureMachineDeletePressureMachinePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PressureMachineResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPressureMachineDeletePressureMachinePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPressureMachineDeletePressureMachinePost$Json(params?: {
    body?: PressureMachineResponse
  }): Observable<PressureMachineResponseDlmBaseResponse> {

    return this.apiPressureMachineDeletePressureMachinePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<PressureMachineResponseDlmBaseResponse>) => r.body as PressureMachineResponseDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiPressureMachineRestorePressureMachinePost
   */
  static readonly ApiPressureMachineRestorePressureMachinePostPath = '/api/PressureMachine/restore-pressure-machine';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPressureMachineRestorePressureMachinePost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPressureMachineRestorePressureMachinePost$Plain$Response(params?: {
    id?: number;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PressureMachineService.ApiPressureMachineRestorePressureMachinePostPath, 'post');
    if (params) {
      rb.query('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPressureMachineRestorePressureMachinePost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPressureMachineRestorePressureMachinePost$Plain(params?: {
    id?: number;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiPressureMachineRestorePressureMachinePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPressureMachineRestorePressureMachinePost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPressureMachineRestorePressureMachinePost$Json$Response(params?: {
    id?: number;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PressureMachineService.ApiPressureMachineRestorePressureMachinePostPath, 'post');
    if (params) {
      rb.query('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPressureMachineRestorePressureMachinePost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPressureMachineRestorePressureMachinePost$Json(params?: {
    id?: number;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiPressureMachineRestorePressureMachinePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiPressureMachinePressureMachineIdCalibrationAttachmentsGet
   */
  static readonly ApiPressureMachinePressureMachineIdCalibrationAttachmentsGetPath = '/api/PressureMachine/{pressureMachineId}/calibration-attachments';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPressureMachinePressureMachineIdCalibrationAttachmentsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPressureMachinePressureMachineIdCalibrationAttachmentsGet$Plain$Response(params: {
    pressureMachineId: number;
  }): Observable<StrictHttpResponse<Array<PressureMachineCalibrationAttachmentDto>>> {

    const rb = new RequestBuilder(this.rootUrl, PressureMachineService.ApiPressureMachinePressureMachineIdCalibrationAttachmentsGetPath, 'get');
    if (params) {
      rb.path('pressureMachineId', params.pressureMachineId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<PressureMachineCalibrationAttachmentDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPressureMachinePressureMachineIdCalibrationAttachmentsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPressureMachinePressureMachineIdCalibrationAttachmentsGet$Plain(params: {
    pressureMachineId: number;
  }): Observable<Array<PressureMachineCalibrationAttachmentDto>> {

    return this.apiPressureMachinePressureMachineIdCalibrationAttachmentsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<Array<PressureMachineCalibrationAttachmentDto>>) => r.body as Array<PressureMachineCalibrationAttachmentDto>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPressureMachinePressureMachineIdCalibrationAttachmentsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPressureMachinePressureMachineIdCalibrationAttachmentsGet$Json$Response(params: {
    pressureMachineId: number;
  }): Observable<StrictHttpResponse<Array<PressureMachineCalibrationAttachmentDto>>> {

    const rb = new RequestBuilder(this.rootUrl, PressureMachineService.ApiPressureMachinePressureMachineIdCalibrationAttachmentsGetPath, 'get');
    if (params) {
      rb.path('pressureMachineId', params.pressureMachineId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<PressureMachineCalibrationAttachmentDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPressureMachinePressureMachineIdCalibrationAttachmentsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPressureMachinePressureMachineIdCalibrationAttachmentsGet$Json(params: {
    pressureMachineId: number;
  }): Observable<Array<PressureMachineCalibrationAttachmentDto>> {

    return this.apiPressureMachinePressureMachineIdCalibrationAttachmentsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<Array<PressureMachineCalibrationAttachmentDto>>) => r.body as Array<PressureMachineCalibrationAttachmentDto>)
    );
  }

  /**
   * Path part for operation apiPressureMachinePressureMachineIdCalibrationAttachmentsPost
   */
  static readonly ApiPressureMachinePressureMachineIdCalibrationAttachmentsPostPath = '/api/PressureMachine/{pressureMachineId}/calibration-attachments';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPressureMachinePressureMachineIdCalibrationAttachmentsPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiPressureMachinePressureMachineIdCalibrationAttachmentsPost$Plain$Response(params: {
    pressureMachineId: number;
    body?: { 'FormFile'?: Blob, 'CalibrationDate'?: string, 'Description'?: string }
  }): Observable<StrictHttpResponse<PressureMachineCalibrationAttachmentDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PressureMachineService.ApiPressureMachinePressureMachineIdCalibrationAttachmentsPostPath, 'post');
    if (params) {
      rb.path('pressureMachineId', params.pressureMachineId, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PressureMachineCalibrationAttachmentDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPressureMachinePressureMachineIdCalibrationAttachmentsPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiPressureMachinePressureMachineIdCalibrationAttachmentsPost$Plain(params: {
    pressureMachineId: number;
    body?: { 'FormFile'?: Blob, 'CalibrationDate'?: string, 'Description'?: string }
  }): Observable<PressureMachineCalibrationAttachmentDtoBaseResponse> {

    return this.apiPressureMachinePressureMachineIdCalibrationAttachmentsPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<PressureMachineCalibrationAttachmentDtoBaseResponse>) => r.body as PressureMachineCalibrationAttachmentDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPressureMachinePressureMachineIdCalibrationAttachmentsPost$Json()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiPressureMachinePressureMachineIdCalibrationAttachmentsPost$Json$Response(params: {
    pressureMachineId: number;
    body?: { 'FormFile'?: Blob, 'CalibrationDate'?: string, 'Description'?: string }
  }): Observable<StrictHttpResponse<PressureMachineCalibrationAttachmentDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PressureMachineService.ApiPressureMachinePressureMachineIdCalibrationAttachmentsPostPath, 'post');
    if (params) {
      rb.path('pressureMachineId', params.pressureMachineId, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PressureMachineCalibrationAttachmentDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPressureMachinePressureMachineIdCalibrationAttachmentsPost$Json$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiPressureMachinePressureMachineIdCalibrationAttachmentsPost$Json(params: {
    pressureMachineId: number;
    body?: { 'FormFile'?: Blob, 'CalibrationDate'?: string, 'Description'?: string }
  }): Observable<PressureMachineCalibrationAttachmentDtoBaseResponse> {

    return this.apiPressureMachinePressureMachineIdCalibrationAttachmentsPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<PressureMachineCalibrationAttachmentDtoBaseResponse>) => r.body as PressureMachineCalibrationAttachmentDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiPressureMachineCalibrationAttachmentsAttachmentIdDownloadGet
   */
  static readonly ApiPressureMachineCalibrationAttachmentsAttachmentIdDownloadGetPath = '/api/PressureMachine/calibration-attachments/{attachmentId}/download';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPressureMachineCalibrationAttachmentsAttachmentIdDownloadGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPressureMachineCalibrationAttachmentsAttachmentIdDownloadGet$Response(params: {
    attachmentId: number;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, PressureMachineService.ApiPressureMachineCalibrationAttachmentsAttachmentIdDownloadGetPath, 'get');
    if (params) {
      rb.path('attachmentId', params.attachmentId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPressureMachineCalibrationAttachmentsAttachmentIdDownloadGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPressureMachineCalibrationAttachmentsAttachmentIdDownloadGet(params: {
    attachmentId: number;
  }): Observable<void> {

    return this.apiPressureMachineCalibrationAttachmentsAttachmentIdDownloadGet$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiPressureMachineCalibrationAttachmentsAttachmentIdDelete
   */
  static readonly ApiPressureMachineCalibrationAttachmentsAttachmentIdDeletePath = '/api/PressureMachine/calibration-attachments/{attachmentId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPressureMachineCalibrationAttachmentsAttachmentIdDelete$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPressureMachineCalibrationAttachmentsAttachmentIdDelete$Plain$Response(params: {
    attachmentId: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PressureMachineService.ApiPressureMachineCalibrationAttachmentsAttachmentIdDeletePath, 'delete');
    if (params) {
      rb.path('attachmentId', params.attachmentId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPressureMachineCalibrationAttachmentsAttachmentIdDelete$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPressureMachineCalibrationAttachmentsAttachmentIdDelete$Plain(params: {
    attachmentId: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiPressureMachineCalibrationAttachmentsAttachmentIdDelete$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPressureMachineCalibrationAttachmentsAttachmentIdDelete$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPressureMachineCalibrationAttachmentsAttachmentIdDelete$Json$Response(params: {
    attachmentId: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PressureMachineService.ApiPressureMachineCalibrationAttachmentsAttachmentIdDeletePath, 'delete');
    if (params) {
      rb.path('attachmentId', params.attachmentId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPressureMachineCalibrationAttachmentsAttachmentIdDelete$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPressureMachineCalibrationAttachmentsAttachmentIdDelete$Json(params: {
    attachmentId: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiPressureMachineCalibrationAttachmentsAttachmentIdDelete$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

}
